export default [
    {
      path: '/admin/address/districts',
      name: 'address-district',
      meta: { requiresAuth: true },
      component: () => import('@/pages/corporate/address/district')
    },
    {
      path: '/admin/address/communes',
      name: 'address-commune',
      meta: { requiresAuth: true },
      component: () => import('@/pages/corporate/address/commune')
    },
    {
      path: '/admin/address/villages',
      name: 'address-village',
      meta: { requiresAuth: true },
      component: () => import('@/pages/corporate/address/village')
    }
  ]
  